import styled from 'styled-components'
import { signInForm } from '../../containers/SignInForm/styles'
import { authCard, authHeader, authScreen } from '../auth-card'

export default styled.article`
  ${ authScreen }

  form {
    ${ authCard }

    ${ authHeader }

    .federated {
      display: flex;
      flex-direction: column;
    }

    ${ signInForm }
  }
`

// The pre-redesign sign in (see appsSignInLayout): wide card, logo, underlined title, centred
// underlined links and the sign up link under the button.
export const StyledClassicArticle = styled.article`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  box-sizing: border-box;

  form {
    ${ signInForm }

    width: 515px;
    max-width: 100%;
    border-radius: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 70px 90px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    background-color: ${ ({ theme }) => theme.colors.white };

    header {
      flex: 0;
      margin-bottom: 25px;
      text-align: center;

      img.logoAmb {
        max-width: 365px;
        width: 100%;
      }

      img.logoNemiRounded,
      img.logoBeiraBaixaRounded {
        max-width: 100px;
      }
    }

    .link span {
      text-decoration: underline;
    }

    .forgotten-password {
      text-align: center;
      margin-top: 0;

      span {
        font-size: 16px;
        font-weight: 500;
      }
    }

    .actions {
      margin-top: 20px;
      padding: 5px;

      .sign-up {
        margin-top: 30px;
      }
    }

    @media screen and (max-width: 768px) {
      padding: 40px 24px;
    }
  }
`
